<template>
  <Form ref="form" :model="form" :rules="ruleValidate" label-position="left" :label-width="80">
    <FormItem label="稿件类型" prop="manuscript_class_id">
      <Select v-model="form.manuscript_class_id" :placeholder="'请选择稿件类型'" filterable>
        <Option v-for="(item, index) in manuscriptList" :value="item.manuscript_class_id" :key="index">{{ item.title }}</Option>
      </Select>
    </FormItem>

    <FormItem required label="标题(蒙古文)" prop="title.mn">
      <textarea class="textarea_mn contentfont" @blur="handleTextareaBlur('title.mn')" v-model="form.title.mn" placeholder="请填写标题(蒙古文)"></textarea>
    </FormItem>
    <FormItem required label="标题" prop="title.zh">
      <Input v-model="form.title.zh" placeholder="请填写标题" @on-blur="handleTextareaBlur('title.zh')"></Input>
    </FormItem>
    <FormItem :required="gjType=='zheshe'?true:false" label="标题(英文)" prop="title.en">
      <Input v-model="form.title.en" placeholder="请填写标题(英文)" @on-blur="handleTextareaBlur('title.en')"></Input>
    </FormItem>


    <FormItem required label="作者(蒙古文)" prop="author.mn" >
      <textarea class="textarea_mn contentfont" @blur="handleTextareaBlur('author.mn')" v-model="form.author.mn" placeholder="请填写作者(蒙古文)"></textarea>
    </FormItem>
    <FormItem required label="作者" prop="author.zh">
      <Input v-model="form.author.zh" placeholder="请填写作者" @on-blur="handleTextareaBlur('author.zh')"></Input>
    </FormItem>
    <FormItem :required="gjType=='zheshe'?true:false" label="作者(英文)" prop="author.en">
      <Input v-model="form.author.en" placeholder="请填写作者(英文)" @on-blur="handleTextareaBlur('author.en')"></Input>
    </FormItem>


    <FormItem required label="关键词(蒙古文)" prop="keywords.mn">
      <textarea class="textarea_mn contentfont" @blur="handleTextareaBlur('keywords.mn')" v-model="form.keywords.mn" placeholder="请填写关键词(蒙古文)"></textarea>
    </FormItem>
    <FormItem required label="关键词" prop="keywords.zh">
      <Input v-model="form.keywords.zh" placeholder="请填写关键词" @on-blur="handleTextareaBlur('keywords.zh')"></Input>
    </FormItem>
    <FormItem :required="gjType=='zheshe'?true:false" label="关键词(英文)" prop="keywords.en">
      <Input v-model="form.keywords.en" placeholder="请填写关键词(英文)" @on-blur="handleTextareaBlur('keywords.en')"></Input>
    </FormItem>

    <FormItem required label="摘要(蒙古文)" prop="zhaiyao.mn">
      <textarea class="textarea_mn contentfont" @blur="handleTextareaBlur('zhaiyao.mn')" v-model="form.zhaiyao.mn" placeholder="请填写摘要(蒙古文)"></textarea>
    </FormItem>
    <FormItem required label="摘要" prop="zhaiyao.zh">
      <Input v-model="form.zhaiyao.zh" type="textarea" :rows="5" placeholder="请填写摘要" @on-blur="handleTextareaBlur('zhaiyao.zh')"></Input>
    </FormItem>
    <FormItem :required="gjType=='zheshe'?true:false" label="摘要(英文)" prop="zhaiyao.en">
      <Input v-model="form.zhaiyao.en" type="textarea" :rows="5" placeholder="请填写摘要(英文)" @on-blur="handleTextareaBlur('zhaiyao.en')"></Input>
    </FormItem>

    <FormItem label="参考文献" prop="references">
      <Input v-model="form.references" type="textarea" :rows="5" placeholder="请填写参考文献"></Input>
    </FormItem>
    <FormItem label="上传文件" prop="files">
      <upload-files-oss v-if="showFile"
                        :format="['wps','pdf','zip','rar','tiff','jpg','png']" :accept="'.wps,.pdf,.zip,.rar,.tiff,.jpg,.png'"
                        multiple :lists="filesList" :isExpert="true" @on-upload="uploadFile($event)" @on-remove="removeFiless($event)" :filedata="filedata">
      </upload-files-oss>
      <span style="color: red">*支持格式wps、pdf、zip、rar、tiff、jpg、png</span>
    </FormItem>

    <FormItem label="通信邮箱" prop="email">
      <Input v-model="form.email" placeholder="请填写通信邮箱"></Input>
    </FormItem>
    <FormItem label="手机号码" prop="tel">
      <Input v-model="form.tel" placeholder="请填写手机号码"></Input>
    </FormItem>

    <FormItem>
      <Checkbox v-model="isAgree" :class="{ 'shake': shouldShake }">同意著作权授权声明</Checkbox>
      <br/>
      <span style="color: red">
        全体作者(著作权人)同意:论文一经《内蒙古师范大学学报(哲学社会科学版)》期刊录用，
        论文全部或部分的复制传播的权利--包括但不限于复制权、发行权、信息网络传播权、汇编权、
        广播权、表演权、翻译权、改编权等将许可给《内蒙古师范大学学报(哲学社会科学版)》编辑部使用，
        《内蒙古师范大学学报(哲学社会科学版)》编辑部除可自行使用外，
        有权许可中国知网等第三方平台使用。许可期限为著作权保护期，
        许可使用范围为全球范围内。许可使用费(含转授权费)双方另行约定
      </span>
    </FormItem>
    <FormItem>
      <Button type="primary" :loading="loading" @click="handleSubmit('form')">提交</Button>
    </FormItem>
  </Form>
</template>

<script>
export default {

  props: {
    infoData: {
      type: [Boolean, Number, String, Array],
      default: false,
    },
  },
  data() {
    // 自定义验证函数 - 至少一个语言标题必填
    // 自定义验证规则 - 必填
    const validateAtLeastOneTitle = (fieldName, language) => {
      return (rule, value, callback) => {
        if(this.gjType=='zheshe'){
          if (!value || value.trim() === '') {
            callback(new Error(`请填写${language}标题`));
          } else {
            callback();
          }
        }else if(this.gjType=='ziran'){
          if (fieldName!='en'&&(!value || value.trim() === '')) {
            callback(new Error(`请填写${language}标题`));
          } else {
            callback();
          }
        }
      };
    };
    const validateAtLeastOneAuthor = (fieldName, language) => {
      return (rule, value, callback) => {
        if(this.gjType=='zheshe'){
          if (!value || value.trim() === '') {
            callback(new Error(`请填写${language}作者`));
          } else {
            callback();
          }
        }else if(this.gjType=='ziran'){
          if (fieldName!='en'&&(!value || value.trim() === '')) {
            callback(new Error(`请填写${language}作者`));
          } else {
            callback();
          }
        }
      };
    };
    const validateAtLeastOneKeywords = (fieldName, language) => {
      return (rule, value, callback) => {
        if(this.gjType=='zheshe'){
          if (!value || value.trim() === '') {
            callback(new Error(`请填写${language}关键词`));
          } else {
            callback();
          }
        }else if(this.gjType=='ziran'){
          if (fieldName!='en'&&(!value || value.trim() === '')) {
            callback(new Error(`请填写${language}关键词`));
          } else {
            callback();
          }
        }
      };
    };
    const validateAtLeastOnezhaiyao = (fieldName, language) => {
      return (rule, value, callback) => {
        if(this.gjType=='zheshe'){
          if (!value || value.trim() === '') {
            callback(new Error(`请填写${language}摘要`));
          } else {
            callback();
          }
        }else if(this.gjType=='ziran'){
          if (fieldName!='en'&&(!value || value.trim() === '')) {
            callback(new Error(`请填写${language}摘要`));
          } else {
            callback();
          }
        }
      };
    };

    return {
      show: true,
      imgsrc: null,
      loading: false,
      showFile:true,
      filesList:[],
      filedata:{
        library_id:localStorage.getItem('libId'),
        model:'Contribute',//模块 book_afterRead读后感  book书籍图片
        filetype:'file',//images（图片）、video（视频）、audio（音频）、file（文件）
      },

      form: {
        library_id:localStorage.getItem('libId'),
        users_id:localStorage.getItem('userInfoMemberId'),
        users_type:localStorage.getItem('user_type'),
        title:{
          mn:'',
          zh:'',
          en:''
        },//标题
        manuscript_class_id:'',//二级稿件类型
        author:{
          mn:'',
          zh:'',
          en:''
        },//作者
        keywords:{
          mn:'',
          zh:'',
          en:''
        },//关键词
        zhaiyao:{
          mn:'',
          zh:'',
          en:''
        },//摘要
        references:'',//参考文献
        email:'',//邮箱
        tel:'',//手机号
        files:[],//附件id
      },
      isAgree:false,
      delfiles:[],


      ruleValidate: {
        manuscript_class_id:[
          { required: true,type:'number',message: '请选择稿件类型', trigger: 'change' }
        ],
        'title.mn':[
          {validator: validateAtLeastOneTitle('mn', '蒙古语'), trigger: 'blur'}
        ],
        'title.zh':[
          {validator: validateAtLeastOneTitle('zh','中文'), trigger: 'blur'}
        ],
        'title.en':[
          {validator: validateAtLeastOneTitle('en','英文'), trigger: 'blur'}
        ],
        'author.mn':[
          {validator: validateAtLeastOneAuthor('mn', '蒙古语'), trigger: 'blur'}
        ],
        'author.zh':[
          {validator: validateAtLeastOneAuthor('zh','中文'), trigger: 'blur'}
        ],
        'author.en':[
          {validator: validateAtLeastOneAuthor('en','英文'), trigger: 'blur'}
        ],
        'keywords.mn':[
          {validator: validateAtLeastOneKeywords('mn', '蒙古语'), trigger: 'blur'}
        ],
        'keywords.zh':[
          {validator: validateAtLeastOneKeywords('zh','中文'), trigger: 'blur'}
        ],
        'keywords.en':[
          {validator: validateAtLeastOneKeywords('en','英文'), trigger: 'blur'}
        ],
        'zhaiyao.mn':[
          {validator: validateAtLeastOnezhaiyao('mn', '蒙古语'), trigger: 'blur'}
        ],
        'zhaiyao.zh':[
          {validator: validateAtLeastOnezhaiyao('zh','中文'), trigger: 'blur'}
        ],
        'zhaiyao.en':[
          {validator: validateAtLeastOnezhaiyao('en','英文'), trigger: 'blur'}
        ],
        references:[
          {required: false, message: '请填写参考文献', trigger: 'blur'}
        ],
        email:[
          {required: true, message: '请填写通信邮箱', trigger: 'blur'},
          { type: 'email', message: '电子邮箱格式错误', trigger: 'blur' }
        ],
        tel:[
          {required: true, message: '请填写手机号码', trigger: 'blur'},
          {pattern: /^1[3456789]\d{9}$/, message: "手机号码格式不正确", trigger: "blur"}
        ],
        files:[
          {required: true,
            validator: (rule, value, callback) => {
              if (!this.delfiles.length&&!this.form.files.length) {
                callback(new Error('请上传文件'));
              } else {
                callback();
              }
            },
            trigger: 'change'}
        ]
      },

      manuscriptList:[],

      shouldShake:false,

      gjType:localStorage.getItem('gjType')?localStorage.getItem('gjType'):''
    }
  },
  methods: {

    /*****************************************************************
     * 多文件上传
     *****************************************************************/
    uploadFile(data) {
      let that = this
      that.form.files = data.map((item) => {
        if (item.response) {
          if (item.response.code == 200) {
            return item.response.data.id
          }
        } else {
          return item.id
        }
      })
    },
    /*****************************************************************
     * 多图删除
     *****************************************************************/
    removeFiless(data) {
      let that = this
      let delid = []
      delid = data.map((item) => {
        if (item.response) {
          if (item.response.code == 200) {
            return {
              id:item.response.data.id,
              type:1
            }
          }
        } else {
          return {
            id:item.files_id,
            type:2
          }
        }
      })
      that.form.files = delid.filter(el => el.type === 1).map(el => el.id)
      that.delfiles = delid.filter(el => el.type === 2).map(el => el.id)

      //delfiles有值代表是旧的没动的，files有值代表是新上传的
      //delfiles无值代表是旧的都删掉了，files无值代表是没有上传的
    },
    //手动绑定原生 textarea 的 blur 事件
    handleTextareaBlur(type){
      this.$refs.form.validateField(type);
    },

    /*****************************************************************
     * 表单验证
     * @param   {name}             要验证的表单名称
     *****************************************************************/
    handleSubmit(name) {
      this.shouldShake = false;
      this.$refs[name].validate((valid) => {
        if (valid) {
          if(!this.isAgree){
            this.shouldShake = false;
            this.$Message.warning('请勾选著作权授权声明!');
            this.shouldShake = true;
            return
          }
          let ss = JSON.parse(JSON.stringify(this.form))
          ss.title = JSON.stringify(ss.title)
          ss.author = JSON.stringify(ss.author)
          ss.keywords = JSON.stringify(ss.keywords)
          ss.zhaiyao = JSON.stringify(ss.zhaiyao)
          this.loading = true
          !this.infoData ? this.addSubmit(ss) : this.editSubmit(ss)
        } else {
          this.loading = false
          this.$Message.error('请核对输入内容!');
        }
      })
    },

    /*****************************************************************
     * 添加数据
     *****************************************************************/
    addSubmit(ss) {
      this.$httpsencrypt.post('api/contributeweb/v3/manuscript/add', ss).then(val => {
        this.$emit('operationState', true)
        this.loading = false
        this.$Message.success('添加成功!');
      }).catch(err => {
        this.loading = false
      })
    },

    /*****************************************************************
     *
     * 修改数据
     *
     *****************************************************************/
    editSubmit(ss) {
      this.$set(ss,'id',this.infoData)
      this.$set(ss,'delfiles',this.delfiles)
      this.$httpsencrypt.post('api/contributeweb/v3/manuscript/edit', ss).then(val => {
        this.$emit('operationState', true)
        this.loading = false;
        this.$Message.success('修改成功!');
      }).catch(err => {
        this.loading = false;
      })

    },

    /*****************************************************************
     *
     * 单条查询数据
     *
     *****************************************************************/
    selData() {
      this.showFile = false
      this.loading = true
      let cond = {
        id:this.infoData,
      }
      this.$httpsencrypt.post('api/contributeweb/v3/manuscript/info',cond).then(val => {
        this.form.manuscript_class_id = val.data.manuscript_class_id?val.data.manuscript_class_id*1:0
        this.form.title = val.data.titlelang
        this.form.author = val.data.authorlang
        this.form.keywords = val.data.keywordslang
        this.form.zhaiyao = val.data.zhaiyaolang
        this.form.references = val.data.references
        this.form.email = val.data.email
        this.form.tel = val.data.tel
        this.form.files = []
        this.delfiles = val.data.files.map(it=>{
          return it.files_id
        })
        this.filesList = val.data.files
        this.showFile = true
        this.loading = false
      }).catch(err => {
        this.showFile = true
        this.loading = false
      })
    },
    /************************************************************
     *
     * 获取专家列表
     *
     ************************************************************/
    getManuscriptList(){
      const _this = this
      let cond = {
        library_id:localStorage.getItem('libId'),
        pid:localStorage.getItem('gjType')?localStorage.getItem('gjType'):''
      }
      _this.$httpsencrypt.post(`api/contributeweb/v3/manuscriptclass/index`,cond)
          .then(val =>{
            if(val.code==200&&val.data.length){
              _this.manuscriptList = val.data
            }else {
              _this.manuscriptList = []
            }
          }).catch(err =>{
        _this.manuscriptList = []
      })
    },


  },
  mounted() {
    this.gjType = localStorage.getItem('gjType')?localStorage.getItem('gjType'):''
    this.getManuscriptList()
    if (this.infoData) this.selData()
  }
};
</script>

<style lang="less" scoped>
/* 抖动动画 */
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
  20%, 40%, 60%, 80% { transform: translateX(5px); }
}
.shake {
  animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
}
</style>
